export default function TwinklingStars() {
	return (
		<div className="px-6 sm:px-8">
			<div className="mx-auto max-w-2xl pt-4 text-center">
				<h2 className="text-2xl font-bold tracking-tight text-white sm:text-4xl">
					Twinkling Stars
				</h2>
				<p className="text-[#f9c04d]">(Ages 3-5)</p>
				<p className="mt-6 text-sm font-bold text-stone-300 sm:text-base">
					Through ballet & tap your future star will explore a world of
					creativity through movement, music, dance, imaginative play &
					emotional expression. Students will learn the basics of classroom
					behavior & manners. Each summer class will end with a show the last 5
					minutes of class!
				</p>
			</div>
			<div className="mt-8 border-t border-stone-600 font-bold">
				<dl className="divide-y divide-stone-600">
					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Disney Dance Adventure</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 8</div>
								<div className="grid justify-end">10:30-11:30am</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Disney Dance Adventure</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 8</div>
								<div className="grid justify-end">5:00-6:00pm</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Pop Star Princess</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 15</div>
								<div className="grid justify-end">10:30-11:30am</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Pop Star Princess</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 15</div>
								<div className="grid justify-end">5:00-6:00pm</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Sparkle Unicorn</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 22</div>
								<div className="grid justify-end">10:30-11:30am</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Sparkle Unicorn</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 22</div>
								<div className="grid justify-end">5:00-6:00pm</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Beach Party Bash</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 29</div>
								<div className="grid justify-end">10:30-11:30am</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Beach Party Bash</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">July 29</div>
								<div className="grid justify-end">5:00-6:00pm</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Zoo-tastic!</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">August 5</div>
								<div className="grid justify-end">10:30-11:30am</div>
							</div>
						</dd>
					</div>

					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Zoo-tastic!</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">August 5</div>
								<div className="grid justify-end">5:00-6:00pm</div>
							</div>
						</dd>
					</div>
				</dl>
				<div className="mx-auto mt-12 max-w-xl space-y-4 border-t border-stone-600 text-center">
					<div className="space-y-2 rounded-lg border border-[#f9c04d] p-4 text-xs text-stone-100 sm:text-sm">
						<div>Drop in fee: $22</div>
						<div>Five week session: $100</div>
					</div>
				</div>
			</div>
		</div>
	)
}
